import { CSSProperties, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { ChatUserInsertInput } from '@school_ify/schoolify-repository/src/shared/types';

import Input from 'components/Input/Text/Input';
import ThemeCheckBox from 'components/Input/CheckBox/ThemeCheckBox';
import ModalDialog from 'components/ModalDialog/ModalDialog';

import './CreateChatModal.scoped.scss';
import { useAppSelector } from 'redux/hooks';
import { selectUserData } from 'redux/editProfile/userProfile.slices';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  openModal?: boolean;
  handleModal?: () => void;
  data?: any[];
  sendData?: (
    data: { title: string; avatar_url: string },
    participants: ChatUserInsertInput[]
  ) => void;
}

const CreateGroupChatPopOver: React.FC<Props> = ({ openModal, handleModal, sendData, data }) => {
  const userData = useAppSelector(selectUserData);
  const { t } = useTranslation('chat');
  const [error, setError] = useState<string>('');
  const [chatInfo, setChatInfo] = useState({
    title: '',
    avatar_url: '',
  });
  const [chosenParticipants, setChosenParticipants] = useState<ChatUserInsertInput[]>([]);

  const sortedUsers = _.orderBy(
    data,
    [user => user.student.user?.full_name.toLowerCase()],
    ['asc']
  );

  function createChat() {
    setError('');
    if (chatInfo.title.length < 1) {
      const err = t('Please_add_chatname');
      setError(err);
      return;
    }
    if (chosenParticipants.length < 1) {
      const err = t('Please_add_at_least_one_participant');
      setError(err);
      return;
    }
    sendData(chatInfo, [...chosenParticipants, { user_id: userData.id }]);
    handleModal();
  }

  useEffect(() => {
    if (!openModal) {
      setChatInfo({
        title: '',
        avatar_url: '',
      });
      setChosenParticipants([]);
    }
  }, [openModal]);

  function checkForSelectedParticipant(id: string) {
    return !!chosenParticipants.find(e => e.user_id === id);
  }

  function toggleParticipant(participant) {
    if (checkForSelectedParticipant(participant.id)) {
      setChosenParticipants(chosenParticipants.filter(item => item.user_id !== participant.id));
      return;
    }
    const convertedPart = {
      user_id: participant.id,
    };
    setChosenParticipants(prevState => [...prevState, convertedPart]);
  }

  return (
    <ModalDialog
      open={openModal}
      onClose={handleModal}
      title={t('chat:Create_Group_Chat')}
      error={error}
      actions={[
        {
          type: 'filled',
          colour: 'primary',
          fullWidth: true,
          label: t('chat:Create_chat'),
          handler: createChat,
        },
      ]}
    >
      <div className="add-task-popover">
        <div className="buttons">
          <div>
            <Input
              onChange={t => {
                setChatInfo({ ...chatInfo, title: t });
              }}
              type="text"
              placeholder={t('chat:Add_chat_name')}
            />
          </div>
          <div className="choose-participants">
            {sortedUsers &&
              sortedUsers.map(e => (
                <div className="participant-item" key={e.id}>
                  <ThemeCheckBox
                    label={e.student.user?.full_name}
                    onChange={() => toggleParticipant(e.student)}
                    checked={checkForSelectedParticipant(e.student.id)}
                    key={e.student.id}
                  >
                    {e.student.user?.full_name}
                  </ThemeCheckBox>
                </div>
              ))}
          </div>
        </div>
      </div>
    </ModalDialog>
  );
};

export default CreateGroupChatPopOver;
